// extracted by mini-css-extract-plugin
export default {"container":"container__eI1SX","module":"module__ojsbw","image":"image__DVIen","label":"label__B8iKL"};